import React from 'react';
import './AccordionStyles.css'; // 👈 CSS styles (provided below)
const extractColorsFromSVG = (svgElement) => {
  const colorMap = new Map();
  const classMap = new Map();
  const elements = svgElement.querySelectorAll('*');

  elements.forEach((el, index) => {
    const computedStyle = window.getComputedStyle(el);
    const fill = computedStyle.fill;
    const rgbToHex = (rgb) => {
      const result = /^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/.exec(rgb);
      return result
        ? `#${((1 << 24) + (parseInt(result[1]) << 16) + (parseInt(result[2]) << 8) + parseInt(result[3]))
          .toString(16)
          .slice(1)}`
        : rgb;
    };
    const fillHex = fill.startsWith('rgb') ? rgbToHex(fill) : fill;
    const className = el.getAttribute('class');

    if (fillHex && fillHex !== 'none') {
      if (!colorMap.has(fillHex)) {
        colorMap.set(fillHex, []);
      }
      if (el.tagName.toLowerCase() === 'rect') {
        colorMap.get(fillHex).push(index);
      }
    }

    if (className) {
      if (!classMap.has(className)) {
        classMap.set(className, []);
      }
      classMap.get(className).push(index);
    }
  });
  return {
    colors: Array.from(colorMap.entries()).map(([hex, indices]) => ({ hex, indices })),
    classes: Array.from(classMap.entries()).map(([className, indices]) => ({ className, indices })),
  };
};
const Patterns = ({ patternData, PatternSVG, setSelectedColor, setRedoStack, setHistory }) => {
  const svgRef = React.useRef(null);
  const [colors, setColors] = React.useState([]);
  const [selectedColorIndex, setSelectedColorIndex] = React.useState(null);
  const sectionTitles = ['HISTORY', 'CULTURAL SIGNIFICANCE', 'PATTERN DESIGN'];
  const clickedShadow = 'inset -3px -3px 3px 0px #FFFFFF, inset 3px 3px 3px 0px #00000033';
  const defaultShadow = '-3px -3px 6px 0px #FFFFFF, 3px 3px 6px 0px #00000033';
  const [clicked, setClicked] = React.useState(null);
  React.useEffect(() => {
    if (svgRef.current) {
      const svgElement = svgRef.current;
      const extractedColors = extractColorsFromSVG(svgElement);
      setColors(extractedColors);
    }
  }, [patternData]);

  const handleColorClick = (color, idx) => {
    setSelectedColor(`#${color.hex}`);
    setClicked(color.hex);

    const existingClasses = JSON.parse(localStorage.getItem('selectedClass')) || [];
    const updatedClasses = Array.isArray(color.class)
      ? [...existingClasses, ...color.class.filter((className) => !existingClasses.includes(className))]
      : existingClasses.includes(color.class)
      ? existingClasses
      : [...existingClasses, color.class];
    localStorage.setItem('selectedClass', JSON.stringify(updatedClasses));
    setHistory((prevHistory) => {
      const newHistory = [...prevHistory];
      newHistory.push(
      Array.isArray(color.class)
        ? color.class[0]
        : [color.class]
      );
      return newHistory;
    });
    setRedoStack([]);
    if (color.class) {
      color.class.forEach((className) => {
        const elementsToShow = document.querySelectorAll(`.${className}C`);
        elementsToShow.forEach((el) => {
          el.classList.add('show');
        });
      });
    }

    setSelectedColorIndex(selectedColorIndex === idx ? null : idx); // Toggle
  };

  return (
    <div style={{ padding: '40px', fontFamily: 'GreycliffCF, sans-serif', background: '#F7F7F7' }}>
      {/* Top Section */}
      <div style={{ display: 'flex', gap: '40px', alignItems: 'start' }}>
        {/* Pattern SVG */}
        <div>
          <div style={{ border: '2px solid #E0E0E0', borderRadius: '8px', padding: '8px', background: '#fff' }}>
            {PatternSVG && <PatternSVG ref={svgRef} style={{ width: '200px', height: '200px' }} />}
          </div>
        </div>

        {/* Text & Colors */}
        <div style={{ flex: 1 }}>
          <h1 style={{ fontFamily: 'Jedira', fontSize: '32px', margin: '0', color: '#1C1C1C' }}>
            {patternData.name || 'Pattern Title'}
          </h1>
          <p style={{ color: '#929292', marginTop: '0', fontSize: '32px' }}>{patternData.gujarati}</p>
          <p style={{ fontSize: '12px',color:"#929292", marginBottom: '10px' }}>Choose the color to fill</p>

          <div style={{ display: 'flex', gap: '0px' }}>
            {patternData.colorCode.map((color, idx) => (
              <div key={idx} style={{ textAlign: 'left', maxWidth: '160px', flex: '1 0 80px',margin:0 }}>
                <div
                  style={{
                    backgroundColor: `#${color.hex}`,
                    width: '30px',
                    height: '30px',
                    borderRadius: '4px',
                    margin: '0 ',
                    cursor: 'pointer',
                    boxShadow: clicked === color.hex ? clickedShadow : defaultShadow,
                  }}
                  onClick={() => handleColorClick(color, idx)}  
                />
                <p style={{ fontSize: '12px', marginTop: '4px', color: '#2E2E2E' }}>
                  <b style={{fontFamily:'Jedira'}}>{color.english}</b><br />
                  <span style={{ color: '#929292', fontFamily:'NotoSerifGujarati' }}>{color.gujarati}</span>
                </p>

                
              </div>
            ))}
          </div>
        </div>
      </div>
      {patternData.colorCode.map((color, idx)=>
        <div className={`accordion ${selectedColorIndex === idx ? 'open' : ''}`}>
                  <div className="accordion-content">
                  <style>
                  {`
          .custom-bullets li::marker {
            color: red; /* Apply color to bullets only */
          }
        `}
                  </style>
                    <ul className='custom-bullets' style={{display:'flex', gap:'20px', listStyleType:'square'}}>
                      
                      {color.description.map((point, i) => (
                        
                        <li key={i} style={{display:'flex',gap:'10px',justifyContent:'center',fontSize:'10px'}}><div
                        style={{
                          minWidth: '10px',
                          height: '10px',
                          backgroundColor: `#${color.hex}`,
                          borderRadius: '2px',
                          marginRight: '1px',
                          marginTop: '5px',
                        }}
                      ></div> {point}</li>
                      ))}
                    </ul>
                  </div>
                </div>
      )}
      {/* Bottom Section */}
      <div style={{ display: 'flex', gap: '30px', marginTop: '40px' }}>
        {sectionTitles.map((title, index) => (
          <div key={index} style={{ flex: 1 }}>
            <h4 style={{ fontSize: '13', color: '#929292' }}>{title}</h4>
            <ul style={{ fontSize: '12px', color: '#2E2E2E', paddingLeft: '18px' }}>
              {patternData.description[index]?.map((text, i) => (
                <li style={{ marginBottom: '10px',fontSize:'12px' }} key={i}>{text}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Patterns;
